import z from 'zod';
import { timelineFilterSchema } from '../components/TimelineFilters/timelineFilterSchema';

export enum TimelineUrlParamsKeys {
    // extended from TimelineFilterSchemaKeys
    ServiceId = 'ServiceId',
    FloorNumber = 'FloorNumber',
    ResourceFeatureId = 'ResourceFeatureId',
    ResourceCategoryId = 'ResourceCategoryId',
    // Extended filters
    DateTime = 'DateTime',
    Period = 'Period',
    // entity preview params
    Reservation = 'Reservation',
    Block = 'block',
    // data for new reservation from timeline
    NewReservationStartUtc = 'NewReservationStartUtc',
    NewReservationEndUtc = 'NewReservationEndUtc',
    NewReservationResourceId = 'NewReservationResourceId',
    NewReservationResourceCategoryId = 'NewReservationResourceCategoryId',
}

export const timelineUrlParamsSchema = timelineFilterSchema.extend({
    [TimelineUrlParamsKeys.Reservation]: z.string().uuid().optional(),
    [TimelineUrlParamsKeys.Block]: z.string().uuid().optional(),
    [TimelineUrlParamsKeys.Period]: z.string().optional(),
    [TimelineUrlParamsKeys.DateTime]: z.string().datetime().optional(),
    [TimelineUrlParamsKeys.NewReservationStartUtc]: z.string().optional(),
    [TimelineUrlParamsKeys.NewReservationEndUtc]: z.string().optional(),
    [TimelineUrlParamsKeys.NewReservationResourceId]: z.string().optional(),
    [TimelineUrlParamsKeys.NewReservationResourceCategoryId]: z.string().optional(),
});

export type TimelineUrlParams = z.infer<typeof timelineUrlParamsSchema>;
